import type { Category, CategoryInput } from '@shop-monorepo/types';
import { useMutation, useQuery } from '@tanstack/react-query';
import { message } from 'antd';

import { apiClient } from '../services/api';

const CATEGORY_QUERY_KEY = ['categories'];

export const useCategories = (
  sorter?: { field?: string; direction?: 'asc' | 'desc' },
  filters?: { isActive?: boolean },
) => {
  return useQuery<Category[], Error>({
    queryKey: [...CATEGORY_QUERY_KEY, sorter, filters],
    queryFn: async () => {
      const data = await apiClient.categories.all(sorter, filters);
      return data;
    },
  });
};

export const useCreateCategory = () => {
  return useMutation<Category, Error, CategoryInput>({
    mutationFn: (newCategory) => apiClient.categories.create(newCategory),
    meta: { invalidates: [CATEGORY_QUERY_KEY] },
    onSuccess: () => {
      message.success('Категорію успішно додано!');
    },
    onError: (error) => {
      message.error(`Не вдалося додати категорію: ${error.message}`);
    },
  });
};

export const useUpdateCategory = () => {
  return useMutation<Category, Error, { id: number; category: CategoryInput }>({
    mutationFn: ({ id, category }) => apiClient.categories.update(id, category),
    meta: { invalidates: [CATEGORY_QUERY_KEY] },
    onSuccess: () => {
      message.success('Категорію успішно оновлено!');
    },
    onError: (error) => {
      message.error(`Не вдалося оновити категорію: ${error.message}`);
    },
  });
};

export const useDeleteCategory = () => {
  return useMutation<
    { message: string },
    Error,
    number // The id of the category to delete
  >({
    mutationFn: (id) => apiClient.categories.delete(id),
    meta: { invalidates: [CATEGORY_QUERY_KEY] },
    onSuccess: () => {
      message.success('Категорію успішно видалено!');
    },
    onError: (error) => {
      message.error(`Не вдалося видалити категорію: ${error.message}`);
    },
  });
};
